export default __webpack_public_path__ + "static/media/screen3.923c2801.png";